/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CommandOrder } from '../model/commandOrder';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ConfiguratorCommandOrderService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createCommandOrder
     *
     * @param commandOrder commandOrder
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCommandOrderUsingPOST(commandOrder: CommandOrder, observe?: 'body', reportProgress?: boolean): Observable<CommandOrder>;
    public createCommandOrderUsingPOST(commandOrder: CommandOrder, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandOrder>>;
    public createCommandOrderUsingPOST(commandOrder: CommandOrder, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandOrder>>;
    public createCommandOrderUsingPOST(commandOrder: CommandOrder, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (commandOrder === null || commandOrder === undefined) {
            throw new Error('Required parameter commandOrder was null or undefined when calling createCommandOrderUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandOrder>(`${this.basePath}/api/commandorders`,
            commandOrder,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteCommandOrder
     *
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCommandOrderUsingDELETE(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCommandOrderUsingDELETE(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCommandOrderUsingDELETE(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCommandOrderUsingDELETE(id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteCommandOrderUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/commandorders/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * finishedCommand
     *
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public finishedCommandUsingPUT(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public finishedCommandUsingPUT(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public finishedCommandUsingPUT(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public finishedCommandUsingPUT(id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling finishedCommandUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/commandorders/${encodeURIComponent(String(id))}/finished`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllCommandOrders
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllCommandOrdersUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<CommandOrder>>;
    public getAllCommandOrdersUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CommandOrder>>>;
    public getAllCommandOrdersUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CommandOrder>>>;
    public getAllCommandOrdersUsingGET(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CommandOrder>>(`${this.basePath}/api/commandorders`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getCommandOrder
     *
     * @param id id
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCommandOrderUsingGET(id: string, token?: boolean, observe?: 'body', reportProgress?: boolean): Observable<CommandOrder>;
    public getCommandOrderUsingGET(id: string, token?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandOrder>>;
    public getCommandOrderUsingGET(id: string, token?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandOrder>>;
    public getCommandOrderUsingGET(id: string, token?: boolean, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getCommandOrderUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CommandOrder>(`${this.basePath}/api/commandorders/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateCommandOrder
     *
     * @param commandOrder commandOrder
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCommandOrderUsingPUT(commandOrder: CommandOrder, observe?: 'body', reportProgress?: boolean): Observable<CommandOrder>;
    public updateCommandOrderUsingPUT(commandOrder: CommandOrder, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandOrder>>;
    public updateCommandOrderUsingPUT(commandOrder: CommandOrder, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandOrder>>;
    public updateCommandOrderUsingPUT(commandOrder: CommandOrder, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (commandOrder === null || commandOrder === undefined) {
            throw new Error('Required parameter commandOrder was null or undefined when calling updateCommandOrderUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandOrder>(`${this.basePath}/api/commandorders`,
            commandOrder,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
